import {addLikertGroupAndQuestions} from "./createPortalJsonObj";
import {getQuestion} from "../constants/customObjConstants";
import * as ddo from "../constants/customObjConstants";
import * as tag from "../constants/customMetadataConstants";
import * as requiredUtil from "../utilities/requiredUtilities";
import * as portalShared from "../shared/metadataConstantsAndUtilities";
import {unanswerQuestion} from "../actions/portalActions";


// -----------------------------------------------------------------------------------------------------------------------------
// Build Show Group from a Instance
// -----------------------------------------------------------------------------------------------------------------------------

export const buildAllShowGroupsArrayFromInstance = (qnr) => {

    let allShowGroupsArrayFromInstance = [];  // Note: each answer can have a different show group

    // Loop through groups in category, if NOT visible then it is a show group related to an answer


    for (let g = 0; g < qnr.questionGroups.length; g++) {

        if (!qnr.questionGroups[g].visible) {

            let group = qnr.questionGroups[g];

            let tempGroupObj = {
                id: group.id,
                templateKey: group.templateKey,
                groupType: group.groupType,
                name: group.name,
                description: group.description,
                metadata: group.metadata.metadataItems,
                visible: false, // If contains a required question only if rendered will portal need to take action
                questions: [],
            };

            // Add in questions for group
            for (let q = 0; q < group.questionIds.length; q++) {

                let question = null;
                for (let qq = 0; qq < qnr.questions.length; qq++) {
                    if (qnr.questions[qq].id === group.questionIds[q]) {
                        question = qnr.questions[qq];
                        break;
                    }
                }

                let tempQuestionObj = {
                    id: question.id,
                    templateKey: question.templateKey,
                    questionType: question.questionType,
                    name: question.name,
                    description: question.description,
                    metadata: question.metadata.metadataItems,
                    visible: false,
                    answers: [],
                };

                // Add in answers for question if exists, only some question types have answers
                for (let a = 0; a < question.answerOptions.length; a++) {

                    let answer = question.answerOptions[a];

                    let tempAnswerObj = {
                        id: answer.id,
                        templateKey: answer.templateKey,
                        name: answer.optionText,
                        showGroupKey: answer.groupKeys[0], // Note: we only allow 1 show group key --- SSSSS Show Group
                        metadata: answer.metadata.metadataItems,
                    };

                    tempQuestionObj.answers.push(tempAnswerObj);

                }

                tempGroupObj.questions.push(tempQuestionObj);

            }

            allShowGroupsArrayFromInstance.push(tempGroupObj);
        }
    }

    return allShowGroupsArrayFromInstance;
}

// -----------------------------------------------------------------------------------------------------------------------------
// Build Show Group from a Graph
// -----------------------------------------------------------------------------------------------------------------------------
export const buildAllShowGroupsArrayFromGraph = (qnr) => {

    let allShowGroupsArrayFromGraph = [];  // Note: each answer can have a different show group

    // Loop through groups in category, if NOT visible then it is a show group related to an answer
    for (let c = 0; c < qnr.questionCategoryTemplates.length; c++) {

        for (let g = 0; g < qnr.questionCategoryTemplates[c].groupTemplates.length; g++) {

            if (!qnr.questionCategoryTemplates[c].groupTemplates[g].visible) {

                let group = qnr.questionCategoryTemplates[c].groupTemplates[g];

                let tempGroupObj = {
                    id: group.id,
                    templateKey: group.templateKey,
                    groupType: group.questionGroupType,
                    name: group.name,
                    description: group.description,
                    metadata: group.metadata,
                    visible: false, // If contains a required question only if rendered will portal need to take action
                    questions: [],
                };

                // Add in questions for group
                for (let q = 0; q < group.questionTemplates.length; q++) {

                    let question = group.questionTemplates[q];

                    let tempQuestionObj = {
                        id: question.id,
                        templateKey: question.templateKey,
                        questionType: question.questionType,
                        name: question.name,
                        description: question.description,
                        metadata: question.metadata,
                        visible: false,
                        answers: [],
                    };

                    // Add in answers for question if exists, only some question types have answers
                    for (let a = 0; a < question.answerOptionTemplates.length; a++) {

                        let answer = question.answerOptionTemplates[a];

                        let tempAnswerObj = {
                            id: answer.id,
                            templateKey: answer.templateKey,
                            name: answer.optionText,
                            showGroupKey: answer.importGroupKeys[0], // Note: we only allow 1 show group key --- SSSSS Show Group
                            metadata: answer.metadata,
                        };

                        tempQuestionObj.answers.push(tempAnswerObj);

                    }

                    tempGroupObj.questions.push(tempQuestionObj);

                }

                allShowGroupsArrayFromGraph.push(tempGroupObj);
            }
        }
    }

    return allShowGroupsArrayFromGraph;
}

// -----------------------------------------------------------------------------------------------------------------------------
// Adds level one show group when the ddo is built
// -----------------------------------------------------------------------------------------------------------------------------

export const addShowGroupToSurvey = (displayDefObj, isInstance, qnr, category, groups, showGroupsObjArray, pageObj, sectionObj, qNumObj) => {

    let questions = null;
    let showGroupKey = "";

    for (let a = 0; a < showGroupsObjArray.length; a++) {

        // Loop through all groups (if !visible then it is a show group
        for (let g = 0; g < groups.length; g++) {

            let group = isInstance ? ddo.getGroupById(qnr, groups[g]) : groups[g]; // Get group associated with the Group ID, in instance mode groups is just an array if IDs;

            // If the answer show group = the group key
            if (showGroupsObjArray[a].showGroupKey === group.templateKey) {

                showGroupKey = group.templateKey;

                // LIKERT Check
                if ((isInstance ? group.groupType : group.questionGroupType) === "LIKERT") {

                    addLikertGroupAndQuestions(displayDefObj, isInstance, qnr, group, pageObj, sectionObj, qNumObj, showGroupKey, showGroupsObjArray);
                }
                else {
                    questions = isInstance ? group.questionIds : group.questionTemplates;

                    questions = (questions === undefined) ? [] : questions;  // In case there are no questions create empty array to avoid errors

                    // Plain Questions, if only one question in the group then the group can have a question number
                    ddo.checkObjForTitlesAndAddSection(pageObj, ddo.OBJ_TYPE.GROUP, group, (questions.length === 1 ? qNumObj : ""), showGroupKey, showGroupsObjArray); // Group titles

                    // Question loop
                    for (let q = 0; q < questions.length; q++) {

                        let question = isInstance ? ddo.getQuestion(qnr, questions[q]) : questions[q];  // Get question associated with Question ID, INSTANCE is just ID, TEMPLATE is question obj;

                        // Add Show Group Question
                        ddo.checkObjForTitlesAndAddSection(pageObj, ddo.OBJ_TYPE.QUESTION, question, qNumObj, showGroupKey, showGroupsObjArray); // Question Titles and question added

                        let showGroupsObjArrayRecursion = getShowGroupObjArray(isInstance, isInstance ? question.answerOptions : question.answerOptionTemplates);

                        //debugger; // ZZZZZ Show Group
                        // ------------------------------------------ NESTED SHOW GROUPS
                        // ---------------------- RECURSION ----------------------------
                        addShowGroupToSurvey(displayDefObj, isInstance, qnr, category, groups, showGroupsObjArrayRecursion, pageObj, sectionObj, qNumObj); // !!!!! RECURSION !!!!! NESTED SHOW GROUPS
                        // ---------------------- RECURSION ----------------------------
                        // ------------------------------------------ NESTED SHOW GROUPS


                        // let nestedShowGroupsObjArray = [];
                        // for (let aa = 0; aa < answers.length; aa++) {
                        //
                        //     let showGroups= isInstance ? answers[aa].groupKeys : answers[a].importGroupKeys;
                        //     let answerObjArray = isInstance ? answers[aa] : answers[a];
                        //
                        //
                        //     if (showGroups.length > 0) {
                        //
                        //     }
                        //
                        // }
                        // ------------------------------------------------------------------------------


                    }
                }

                break;
            }
        }
        //}

    }
};

// -----------------------------------------------------------------------------------------------------------------------------
// Get level one show group array
// -----------------------------------------------------------------------------------------------------------------------------

export const getShowGroupObjArray = (isInstance, answers) => {

    let showGroupObjArray = [];  // Note: each answer can have a different show group
    let showGroupKey = null;  // Note: A single answer is now restricted to a single show group

    if (answers !== undefined) {
        for (let i = 0; i < answers.length; i++) {

            // SSSSS Show Group
            showGroupKey = isInstance ? (answers[i].groupKeys.length > 0 ? answers[i].groupKeys[0] : "") : (answers[i].importGroupKeys.length > 0 ? answers[i].importGroupKeys[0] : ""); // Note: A single answer is NOW restricted to a single show group, structure is still an array

            if (showGroupKey !== "") {
                // Only add distinct show group keys
                if (!showGroupObjArray.some(e => e.showGroupKey === showGroupKey)) { // eslint-disable-line
                    showGroupObjArray.push({debugAnswerText: answers[i].optionText, answerId: answers[i].id, answerKey: answers[i].templateKey, showGroupKey: showGroupKey}); // eslint-disable-line
                }
            }
        }
    }

    return showGroupObjArray;
}

// -----------------------------------------------------------------------------------------------------------------------------
// ???? Not currently used
// -----------------------------------------------------------------------------------------------------------------------------

// export const containsShowGroup = (answers) => {
//
//     let showGroup = "";
//
//     // NOTE: Currently we only consider a question can only have a single show group  --- SSSSS Show Group
//     for (let i = 0; i < answers.length; i++) {
//         if ((answers[i].groupKeys.length > 0) && (answers[i].groupKeys[0] !== "")) {
//             showGroup = answers[i].groupKeys[0]; // --- SSSSS Show Group
//         }
//     }
//
//     return showGroup;
// }

// -----------------------------------------------------------------------------------------------------------------------------
// ???? Not currently used
// -----------------------------------------------------------------------------------------------------------------------------

// export const templateModeAddShowGroup = (qnr, category, group, question) => {
//
//     let showGroupKeyArray = [];
//
//     let answers = question.answerOptionTemplates;
//
//     if (answers !== undefined) {
//
//         for (let a = 0; a < answers.length; a++) {
//
//             let importGroupKeys = answers[a].importGroupKeys;
//
//             if (importGroupKeys !== undefined) {
//
//                 for (let k = 0; k < importGroupKeys.length; k++) {
//
//                     let showGroupTemplateKey = importGroupKeys[k];
//                     if (!showGroupKeyArray.includes(showGroupTemplateKey)) {
//
//                         showGroupKeyArray.push(showGroupTemplateKey);
//                     }
//                 }
//             }
//         }
//     }
//
//     return showGroupKeyArray;
// };


export const showGroup = (questionnaire, showGroupKey) => {

    // ZZZZZ Show Group
    // determine if a show group should be visible or hidden style={{display: showGroupUtil.showGroup(qnr, showGroupKey) ? "inline" : "none"}}
    //debugger;
    let show = false;

    let isInstance = questionnaire.questions !== undefined;

    // BUTTONS have undefined showGroupKey
    if ((showGroupKey === "")||(showGroupKey === undefined)) {
        show = true; // no showGroupKey then always visible
    }
    else {

        let qnr = questionnaire;
        //let isInstance = questionnaire.questions !== undefined;

        let categories = null;
        let groups = null;
        let questions = null;
        let question = null;

        if (isInstance) {

            questions = qnr.questions;

            for (let i = 0; i < questions.length; i++) {

                if (!tag.metadataExists(questions[i], portalShared.DO_NOT_USE_SHOW_GROUP)) {

                    for (let j = 0; j < questions[i].answerOptions.length; j++) {

                        for (let k = 0; k < questions[i].answerOptions[j].groupKeys.length; k++) {

                            // Check to see if the answer has a showGroup SSSSS Show Group
                            if (questions[i].answerOptions[j].groupKeys[k] === showGroupKey) {

                                // If answered that triggers then make showGroup visible
                                if (questions[i].answerOptions[j].selected) {

                                    show = true;
                                    break;
                                }
                            }
                        }
                    }

                }
            }
        }
        else {

            categories = qnr.questionCategoryTemplates;

            for (let c = 0; c < categories.length; c++) {

                groups = categories[c].groupTemplates !== undefined ? categories[c].groupTemplates : [];

                for (let g = 0; g < groups.length; g++) {

                    questions = groups[g].questionTemplates !== undefined ? groups[g].questionTemplates : [];

                    for (let q = 0; q < questions.length; q++) {

                        question = questions[q];

                        if (!tag.metadataExists(question, portalShared.DO_NOT_USE_SHOW_GROUP)) {

                            for (let j = 0; j < question.answerOptionTemplates.length; j++) {

                                for (let k = 0; k < question.answerOptionTemplates[j].importGroupKeys.length; k++) {

                                    // Check to see if the answer has a showGroup SSSSS Show Group ZZZZZ Show Group
                                    if (question.answerOptionTemplates[j].importGroupKeys[k] === showGroupKey) {

                                        // If answered then make showGroup visible
                                        if ((question.answerOptionTemplates[j].selected !== undefined) && question.answerOptionTemplates[j].selected) {

                                            show = true;
                                            break;
                                        }
                                    }
                                }
                            }

                        }

                    }
                }
            }

        }
    }

    return show;
}


export const unanswerShowGroupQuestions = (qnr, dataDefObj, parentQuestion, showGroupKey) => {

    let isInstance = qnr.questions !== undefined;

    if (isInstance) {

        for (let g = 0; g < qnr.questionGroups.length; g++) {

            if (qnr.questionGroups[g].templateKey === showGroupKey) {

                let group = qnr.questionGroups[g];

                group.visible = false; // Set group back to NOT visible // ?????????? what if show group is triggered from a range of answers ??????????

                for (let q = 0; q < group.questionIds.length; q++) {

                    let question = getQuestion(qnr, group.questionIds[q]);

                    // ----------------------------------------------------------------------------------
                    // un-answer all types
                    // ----------------------------------------------------------------------------------

                    // ----------------------------------------------------------------------------------
                    unanswerQuestion(question); // Make Action call to call API, Action will check to see if API needs to be called
                    // ----------------------------------------------------------------------------------

                    question.answerText = "";

                    if (question.hasOwnProperty("addressAnswerDTO")) {
                        question.addressAnswerDTO = {address: "", extended: "", city: "", zipPostalCode: ""};
                    }

                    if (question.questionType === portalShared.RANKING) {

                        for (let rq = 0; rq < dataDefObj.rankingQuestionsDefaultOrder.length; rq++) {
                            if (dataDefObj.rankingQuestionsDefaultOrder[rq].id === question.id) {
                                question.answerOptions = dataDefObj.rankingQuestionsDefaultOrder[rq].answerOptions;
                            }
                        }

                    }

                    // Add in answers for question if exists, only some question types have answers
                    for (let a = 0; a < question.answerOptions.length; a++) {

                        question.answerOptions[a].selected = false; // un-answer NOTE: Single Select and Multi-select both use the property selected

                        // ------------------------------------------------------------------------------------------------------------------- RECURSION
                        if (question.answerOptions[a].groupKeys.length > 0) {
                            unanswerShowGroupQuestions(qnr, dataDefObj, question, question.answerOptions[a].groupKeys[0]); // -------- RECURSION
                        }
                        // ------------------------------------------------------------------------------------------------------------------- RECURSION

                    }

                    if (!question.optional) {
                        requiredUtil.setRequiredAnswered("SRA-19", question.id, dataDefObj, false); // Reset required
                    }

                    unanswerQuestion(question);

                    // ----------------------------------------------------------------------------------

                }
            }
        }

    } else {

        // Loop through groups in category, if NOT visible then it is a show group related to an answer
        for (let c = 0; c < qnr.questionCategoryTemplates.length; c++) {

            for (let g = 0; g < qnr.questionCategoryTemplates[c].groupTemplates.length; g++) {

                if (qnr.questionCategoryTemplates[c].groupTemplates[g].templateKey === showGroupKey) {

                    let group = qnr.questionCategoryTemplates[c].groupTemplates[g];

                    group.visible = false;

                    for (let q = 0; q < group.questionTemplates.length; q++) {

                        let question = group.questionTemplates[q];

                        // ----------------------------------------------------------------------------------
                        // un-answer all types
                        // ----------------------------------------------------------------------------------
                        // un-answer question

                        question.answerText = "";

                        if (question.hasOwnProperty("addressAnswer")) {
                            question.addressAnswer = {address: "", extended: "", city: "", zipPostalCode: ""}; // un-answer question
                        }

                        if (question.questionType === portalShared.RANKING) {

                            for (let rq = 0; rq < dataDefObj.rankingQuestionsDefaultOrder.length; rq++) {
                                if (dataDefObj.rankingQuestionsDefaultOrder[rq].id === question.id) {
                                    question.answerOptionTemplates = dataDefObj.rankingQuestionsDefaultOrder[rq].answerOptionTemplates;
                                }
                            }

                        }

                        // Add in answers for question if exists, only some question types have answers
                        for (let a = 0; a < question.answerOptionTemplates.length; a++) {
                            question.answerOptionTemplates[a].selected = false; // // un-answer question NOTE: Single Select and Multi-select both use the property selected

                            // ------------------------------------------------------------------------------------------------------------------- RECURSION
                            if (question.answerOptionTemplates[a].importGroupKeys.length > 0) {
                                unanswerShowGroupQuestions(qnr, dataDefObj, question, question.answerOptionTemplates[a].importGroupKeys[0]); // -- RECURSION
                            }
                            // ------------------------------------------------------------------------------------------------------------------- RECURSION

                        }

                        if (!question.optional) {
                            requiredUtil.setRequiredAnswered("SRA-13", question.id, dataDefObj, false); // Reset required
                        }

                        // ----------------------------------------------------------------------------------

                    }
                }
            }
        }

    }

}



export function getAllShowGroupKeyArray(questionnaire) {

    let allShowGroupKeyArray = [];

    let qnr = questionnaire;
    let isInstance = questionnaire.questions !== undefined;

    let categories = null;
    let groups = null;
    let questions = null;
    let answers = null;
    let groupKeys = null;

    if (isInstance) {
        questions = isInstance ? qnr.questions : qnr.questionTemplates;

        for (let q = 0; q < questions.length; q++) {

            answers = questions[q].answerOptions;

            for (let a = 0; a < answers.length; a++){

                let groupKeys = answers[a].groupKeys;

                for (let k = 0; k < groupKeys.length; k++) {

                    let showGroupTemplateKey = groupKeys[k];
                    if (!allShowGroupKeyArray.includes(showGroupTemplateKey)) {

                        allShowGroupKeyArray.push(showGroupTemplateKey);
                    }
                }
            }
        }
    }
    else {
        categories = qnr.questionCategoryTemplates;

        // Issues with debugging so using var instead of let
        for (let c = 0; c < categories.length; c++) {

            groups = categories[c].groupTemplates !== undefined ? categories[c].groupTemplates : [];

            for (let g = 0; g < groups.length; g++) {

                questions = groups[g].questionTemplates !== undefined ? groups[g].questionTemplates : [];

                for (let q = 0; q < questions.length; q++) {

                    answers = questions[q].answerOptionTemplates;

                    if (answers !== undefined) {

                        for (let a = 0; a < answers.length; a++){

                            groupKeys = answers[a].importGroupKeys;

                            if (groupKeys !== undefined) {

                                for (let k = 0; k < groupKeys.length; k++) {

                                    let showGroupTemplateKey = groupKeys[k];
                                    if (!allShowGroupKeyArray.includes(showGroupTemplateKey)) {

                                        allShowGroupKeyArray.push(showGroupTemplateKey);
                                    }
                                }
                            }
                        }
                    }
                }
            }
        }
    }

    return allShowGroupKeyArray;
}




export function getShowGroupKey(qnr, question, obj) {
    // SSSSS Show Group

    let isInstance = qnr.questions !== undefined;

    let showGroupKey = "";

    if (obj["showGroupKey"] !== "") {
        showGroupKey = obj["showGroupKey"];
    } else if (obj["showGroupObjArray"].length > 0) {

        for (let i = 0; i < obj.showGroupObjArray.length; i++) {

            let group = ddo.getGroupByKey(qnr, obj.showGroupObjArray[i].showGroupKey);

            // SSSSS Show Group *****Note: currently template mode is different between edit template and graph call, edit does NOT have show groups
            if (group !== null) {

                // Check put in because under some condition question is NULL
                if (question) {

                    // Loop through all questions in the group and see if the group is this questions parent
                    if (isInstance) {

                        for (let q = 0; q < group.questionIds.length; q++) {
                            if (group.questionIds[q] === question.id) {
                                showGroupKey = group.templateKey;
                                break;
                            }
                        }

                    } else {

                        for (let q = 0; q < group.questionTemplates.length; q++) {

                            if (question && (group.questionTemplates[q].id === question.id)) {
                                showGroupKey = group.templateKey;
                                break;
                            }
                        }

                    }
                }

            }

        }

    }

    return showGroupKey;
}